import { useQuery  } from "react-query";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { RouteContextType } from "../../hooks/use-route-context/UseRouteContext";
import CustomFormsDataService from "../../services/custom-forms-data-service/CustomFormsDataService";
import { IFormTemplate } from "../../services/custom-forms-data-service/TemplateModels";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseCustomFormTemplateQueryParameters = {
    customerID: number,
    routeContext: RouteContextType,
    offlineDataLoaded: boolean,
    offline: boolean
} & BaseUseQueryParameters<IFormTemplate[]>

export function useCustomFormTemplate(
    params: UseCustomFormTemplateQueryParameters
) {
    return useQuery<IFormTemplate[] | undefined, RestError>(
        keys.data(params.customerID,
            params.routeContext,
            params.offlineDataLoaded,            
            params.offline
            ),
        ({ signal }) => {
            if (params.customerID) {
                return CustomFormsDataService.getTemplates(params.customerID,
                    params.routeContext.groupID as number,
                    params.routeContext.contextObject?.objectType as eLynxObjectTypeEnum,
                    params.offline,
                    signal
                );
            }
        },
        {
            enabled: params.enabled,
            onError: params.onError,
            onSuccess: params.onSuccess,
            //refetchInterval: params.refreshSeconds ? params.refreshSeconds  * 1000 : false,
            //keepPreviousData: true
            //staleTime: 0
        }
    );
}

